import { Injectable, forwardRef, Inject } from '@angular/core';

import { ApiService }        from '../api/api.service';
import { SessionService } from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class EmailVerificationService {
  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService     : ApiService,
    @Inject(forwardRef(() => SessionService))
    private sessionService : SessionService
  ) {}

  checkVerificationStatus () : ng.IPromise<boolean> {
    return this.apiService.get('/amazon_web_services/check_email_verification_status');
  }

  didVerificationFail ( company : any = this.getCompany() ) : boolean {
    return company.email_verified === 'N';
  }

  getCompany () : any {
    return this.sessionService.company();
  }

  isEmailPending ( company : any = this.getCompany() ) : boolean {
    return company.email_verified === 'P';
  }

  isEmailUnverified ( company : any = this.getCompany() ) : boolean {
    return !company.email_verified;
  }

  isEmailVerified ( company : any = this.getCompany() ) : boolean {
    return company.email_verified === 'V';
  }

  verify () : ng.IPromise<boolean> {
    return this.apiService.get('/company/verify_email_address');
  }
}